<template>
  <div class="home">
    <NavigationBar ref="navg" />
    <div style="flex:1;">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </div>
  </div>

</template>

<script>
import NavigationBar from '@/components/NavigationBar.vue'

export default {
  name: 'Root',
  components: {
    NavigationBar
  },
  created() {
    // this.refresh()
  },
  methods: {
    refresh() {
      // this.$eventBus.$emit('user_logined', '传递的参数')
    }
  }
}
</script>

<style scoped>
  .home {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
</style>
